<!--
  ModalShell — the overlay + card + title bar + close button that every admin
  modal repeats. v-model:open controls visibility; the body goes in the default
  slot. Click-outside and the ✕ both close. Keeps each view free of boilerplate
  modal chrome so the bodies stay the only thing that differs.
-->
<template>
  <div v-if="open" class="ms-overlay" @click.self="close">
    <div class="ms-card" :style="maxWidth ? { maxWidth } : undefined">
      <div class="ms-head">
        <h3 class="ms-title">{{ title }}</h3>
        <button type="button" class="ms-close" title="Close" @click="close">✕</button>
      </div>
      <div class="ms-body">
        <p v-if="loading" class="ms-muted">Loading…</p>
        <slot v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ open: boolean; title?: string; loading?: boolean; maxWidth?: string }>()
const emit = defineEmits<{ (e: 'update:open', v: boolean): void }>()
function close() { emit('update:open', false) }
</script>

<style scoped>
.ms-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 1rem; }
.ms-card { background: var(--bg-surface); color: var(--text-primary); border: 1px solid var(--border-default); border-radius: var(--radius-md, 10px); padding: 1.25rem; max-width: 440px; width: 100%; max-height: 85vh; overflow-y: auto; }
.ms-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem; }
.ms-title { margin: 0; font-size: 1.05rem; }
.ms-close { background: transparent; border: none; color: var(--text-muted); cursor: pointer; font-size: 1rem; padding: 0.2rem 0.4rem; border-radius: var(--radius-sm); }
.ms-close:hover { color: var(--text-primary); background: var(--bg-elevated); }
.ms-muted { color: var(--text-muted); font-size: 0.85rem; }
</style>
